import { ToastContent } from '@lyrahealth-inc/ui-core-crossplatform/src/ui-models/toast/Toast'

import { CLEAR_TOAST_CONTENT, SET_TOAST_CONTENT } from '../../common/constants/reduxConstants'

export const setToastContent = (content: ToastContent) => {
  return {
    content,
    type: SET_TOAST_CONTENT,
  }
}

export const clearToastContent = (id?: string) => {
  return {
    id,
    type: CLEAR_TOAST_CONTENT,
  }
}
